import React from "react";
import { SERVICES } from "@/lib/site-data";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-28 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 mb-20 items-end">
          <div className="md:col-span-5 reveal">
            <div className="flex items-center gap-4 mb-6">
              <span className="hairline w-10" />
              <span className="eyebrow">What We Do</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl leading-[1.05] tracking-tight text-[var(--text-primary)]">
              Services <em className="text-[var(--accent)]">built</em> around
              the work you value most.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 reveal reveal-delay-1">
            <p className="text-[var(--text-secondary)] text-lg leading-relaxed">
              From single-room remodels to ground-up developments, every
              engagement is handled with the same disciplined craft. One team.
              Transparent pricing. Zero excuses.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
          {SERVICES.map((s, idx) => (
            <ServiceCard key={s.n} {...s} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ n, title, desc, idx }) {
  return (
    <article
      className="group relative border-r border-b border-white/10 p-10 md:p-12 transition-colors duration-500 hover:bg-[var(--bg-secondary)] reveal"
      style={{ transitionDelay: `${(idx % 3) * 80}ms` }}
      data-testid={`service-card-${n}`}
    >
      <div className="flex items-start justify-between mb-8">
        <span className="num-marker text-4xl">{n}</span>
        <svg
          className="opacity-0 group-hover:opacity-100 translate-x-[-6px] group-hover:translate-x-0 transition-all duration-500 text-[var(--accent)]"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.4"
        >
          <path d="M7 17L17 7M7 7h10v10" />
        </svg>
      </div>
      <h3 className="font-display text-2xl md:text-3xl leading-tight text-[var(--text-primary)] mb-5">
        {title}
      </h3>
      <p className="text-[var(--text-secondary)] leading-relaxed text-[15px]">
        {desc}
      </p>
    </article>
  );
}
